import {
    addMinutes,
    differenceInMilliseconds,
    getTimestamp,
    now,
    startOfMinute,
    today,
} from 'owa-datetime';
import { initializeOwaObservableDateTime } from './actions';
import { MILLISECONDS_IN_MINUTE } from 'owa-date-constants';
import { observableNowChanged, observableTodayChanged } from './actions';
import { orchestrator } from 'satcheljs';
import { setLocalTimeZone } from 'owa-datetime-store';
import { updateTimes, setNow, setToday } from './privateActions';
import getStore from './store';

orchestrator(initializeOwaObservableDateTime, () => {
    updateTimes();

    const NOW = now();
    const startOfNextMinute = startOfMinute(addMinutes(NOW, 1));
    const msToNextMinute = differenceInMilliseconds(startOfNextMinute, NOW);

    setTimeout(() => setInterval(updateTimes, MILLISECONDS_IN_MINUTE), msToNextMinute);
});

/** Recalculate 'today' when the time zone changes */
orchestrator(setLocalTimeZone, () => {
    updateTimes();
});

/**
 * Update the store with the timestamp of now and
 * the start of the current day in the current time zone,
 * then raise public events so orchestrators that depend
 * on these values can run.
 */
orchestrator(updateTimes, () => {
    setNow();

    const newToday = getTimestamp(today());
    const isNewDay = getStore().today != newToday;
    if (isNewDay) {
        setToday(newToday);
    }

    observableNowChanged();
    if (isNewDay) {
        observableTodayChanged();
    }
});
